import { ReactNode } from 'react';

export enum ImageType {
  ROUND = 'round',
  SQUARE = 'square',
  COVER = 'cover',
}

export interface IImageFieldProps {
  className?: string;
  name: string;
  value: string | null;
  type?: ImageType;
  renderImage?: (url: string) => ReactNode;
  emptyImage?: ReactNode;
  onChange?: TChangeHandler;
  onLoad?: TLoadHandler;
}

export interface IImageLoadHandlerParams {
  type: ImageType;
  image: string;
  onChange(url: string): void;
}

export type TChangeHandler = (value: string | null) => void;
export type TLoadHandler = (params: IImageLoadHandlerParams) => void;
